import React from "react";
import { Link } from "react-router-dom";

const CarouselCard = ({
  title,
  info,
  img,
  link,
  personsTitle,
  email,
  name,
  alt,
  bgColor,
}) => {
  return (
    <div
      className={`${!img && "py-12 w-full"} text-black ${
        bgColor === "primary" ? "bg-primary" : "bg-black"
      } min-h-full ${
        !img ? "min-w-[220px]" : "w-[400px]"
      } flex-col justify-center items-center mx-4`}
    >
      <div className="flex justify-center px-8 items-center text-white w-full mt-2.5">
        {link ? (
          <Link to={link}>
            <img
              className={`${
                !img ? "h-0" : "h-[200px] w-[200px] min-h-[200px] min-w-[200px]"
              } overflow-hidden object-cover`}
              src={img}
              alt={alt}
            />
          </Link>
        ) : (
          <img
            className={`${
              !img ? "h-0" : "h-[200px] w-[200px] min-h-[200px] min-w-[200px]"
            }  object-cover`}
            src={img}
            alt={alt}
          />
        )}
      </div>
      <div
        className={`${
          bgColor === "primary"
            ? "text-center text-black mt-1 min-h-[80px] w-full flex-col"
            : "text-center text-primary mt-1 min-h-[80px] w-full flex-col"
        }`}
      >
        {link ? (
          <Link to={link}>
            <h1 className="text-3xl mx-auto">{title}</h1>
          </Link>
        ) : (
          <h1 className="text-3xl mx-auto">{title}</h1>
        )}

        {info && <p className="text-white py-6 px-0.5">{info}</p>}
        {/* who we are only */}
        <h2
          className={`${
            bgColor === "primary" ? "text-black" : "text-primary"
          } whitespace-nowrap pb-3 font-bold text-4xl`}
        >
          {name}
        </h2>
        <p className="pb-2 font-bold">{personsTitle}</p>
        {email && <p className="text-sm">{"Email: " + email}</p>}
        {/* who we are only */}
        {link && (
          <Link to={link}>
            <p className="underline underline-offset-2">Learn More</p>
          </Link>
        )}
      </div>
    </div>
  );
};

export default CarouselCard;
